"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
import { crmKeyBenefits } from "./crm.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmKeyBenefits() {
  const $ = _c(21);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      once: true,
      amount: 0.3
    };
    t4 = {
      duration: 0.7,
      ease
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="font-poppins mb-4 text-[28px] font-bold leading-[1.35] text-[#0b1354] md:text-[36px] dark:text-white">Key Benefits of On-Demand Home{" "}<span className="text-[#1aad6f]">Service App Development</span></h2>;
    t6 = <p className="mx-auto mb-0 max-w-[740px] font-sans text-[16px] font-normal leading-[27px] text-[#6b7280] dark:text-gray-300">A custom home service app streamlines operations, enhances customer convenience, and boosts business growth—all in one platform.</p>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2) {
    t7 = <motion.div initial={t0} whileInView={t1} animate={t2} viewport={t3} transition={t4} className="mx-auto mb-10 max-w-[760px] text-center md:mb-14">{t5}{t6}</motion.div>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== desktopAnimations) {
    t8 = crmKeyBenefits.map((item, index) => <div key={item.title} className={`h-full ${index % 3 === 1 ? "lg:-translate-y-8" : ""}`}><motion.article initial={desktopAnimations ? {
        opacity: 0,
        y: 40
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.65,
        delay: index * 0.08,
        ease
      }} className="group relative flex h-full flex-col overflow-hidden rounded-[16px] bg-white dark:bg-gray-800/90 dark:border dark:border-gray-700/80 px-[30px] pt-[50px] pb-[50px] shadow-[0_6px_28px_rgba(20,60,100,0.07)] dark:shadow-none transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] hover:-translate-y-[7.5px]"><Image src={item.icon} alt={item.title} width={144} height={144} className="mb-5 h-[72px] w-[72px] object-contain" /><h3 className="font-poppins mb-3 text-[22px] font-bold leading-[34px] text-[#0b1354] dark:text-white">{item.title}</h3><p className="mb-0 font-sans text-[16px] font-normal leading-[30px] text-[#6b7280] dark:text-gray-300">{item.description}</p><span className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-[linear-gradient(135deg,#9100ff_0%,#3663ff_54%,#00e2ff_100%)] transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:scale-x-100" /></motion.article></div>);
    $[14] = desktopAnimations;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <div className="grid grid-cols-1 items-stretch gap-9 md:grid-cols-2 lg:grid-cols-3">{t8}</div>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <section className="bg-gradient-to-b from-[#DBF2FF] from-[10%] to-[#FFFFFF] dark:from-gray-900 dark:to-gray-950 py-[70px] transition-colors duration-300 md:py-[100px]"><div className="mx-auto w-full max-w-[1240px] px-[15px]">{t7}{t9}</div></section>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}